import { createRoutine } from "../utils/routine.utils";
export var getCount = createRoutine("COUNT_GET");
